import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useParams } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import api from "../../utils/api";
import {
  successAlert,
  errorAlert,
  loadingAlert,
  closeAlert,
} from "../../utils/swalConfig";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    passwordConfirm: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (formData.password !== formData.passwordConfirm) {
        return errorAlert("Error", "Passwords do not match");
      }

      setLoading(true);
      loadingAlert("Resetting password...");

      await api.patch(`/users/resetPassword/${token}`, formData);

      closeAlert();
      await successAlert("Success!", "Password has been reset successfully");
      navigate("/login");
    } catch (err) {
      closeAlert();
      errorAlert(
        "Error",
        err.response?.data?.message || "Failed to reset password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" component="h1" gutterBottom align="center">
              Reset Password
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="New Password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
                sx={{ mb: 2 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                label="Confirm Password"
                type="password"
                value={formData.passwordConfirm}
                onChange={(e) =>
                  setFormData({ ...formData, passwordConfirm: e.target.value })
                }
                required
                sx={{ mb: 3 }}
              />
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                type="submit"
              >
                Reset Password
              </LoadingButton>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default ResetPassword;
